import React from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {

    const navigate = useNavigate();
    const pageNavigate = (path) => {
        navigate(`/${path}`);

    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
            <img
                src={'./images/unauthorized.jpg'}
                alt="Unauthorized Access"
                className="w-100 h-100 mb-6 rounded-lg"
            />
            <h1 className="text-4xl font-bold text-gray-500 mb-4">
                Unauthorized Access
            </h1>
            <p className="text-lg text-gray-600 mb-6 text-center">
                Sorry, you don't have permission to view this page. Please log in or contact the administrator for access.
            </p>
            <button
                onClick={() => pageNavigate("")}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-500 focus:outline-none"
            >
                Go to Home
            </button>
        </div>
    );
};

export default Unauthorized;
